'use client';

import React, { useState } from 'react';
import AuthLeftPanel from './AuthLeftPanel';
import SignInForm from './SignInForm';
import SignUpForm from './SignUpForm';

export default function AuthContainer() {
  const [activeTab, setActiveTab] = useState<'signin' | 'signup'>('signin');

  return (
    <div className="min-h-screen flex" style={{ background: 'var(--background)' }}>
      {/* Left brand panel */}
      <AuthLeftPanel />

      {/* Right form panel */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 py-12 overflow-y-auto scrollbar-thin">
        <div className="w-full max-w-md">
          {/* Tab switcher */}
          <div
            className="flex rounded-xl p-1 mb-8"
            style={{ background: 'var(--card)', border: '1px solid var(--border)' }}
          >
            <button
              onClick={() => setActiveTab('signin')}
              className={`flex-1 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
                activeTab === 'signin' ?'gradient-amber text-black shadow-sm' :'hover:bg-muted'
              }`}
              style={{ color: activeTab === 'signin' ? '#000' : 'var(--muted-foreground)' }}
            >
              Sign In
            </button>
            <button
              onClick={() => setActiveTab('signup')}
              className={`flex-1 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 ${
                activeTab === 'signup' ?'gradient-amber text-black shadow-sm' :'hover:bg-muted'
              }`}
              style={{ color: activeTab === 'signup' ? '#000' : 'var(--muted-foreground)' }}
            >
              Create Account
            </button>
          </div>

          {activeTab === 'signin' ? (
            <SignInForm />
          ) : (
            <SignUpForm onSwitchToSignIn={() => setActiveTab('signin')} />
          )}
        </div>
      </div>
    </div>
  );
}